module.exports = __webpack_public_path__ + "assets/d208693da408e46d556245b970feba4c.png";